module.exports = __webpack_public_path__ + "img/editorial5.82584cb0.jpg";